import { Body } from '../postPage.reducer';

export const createBlockNames = (body: Body | null) => (body ? body.map(block => block.type) : []);
